<template>
  <div>
    <!--       v-if="selectedData" -->
    <el-dialog
      title="Nhập danh sách phòng"
      :visible.sync="dialogUpdateRoomVisible"
      :close-on-click-modal="false"
      width="60%"
      @closed="onCloseUpdateRoomDialog"
    >
      <!-- <div class="content-container"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-group-title">Thông tin đoàn phụ</div>
              <InfoList
                :columns="4"
                :column-breakpoint-options="{
                  sm: 1,
                  md: 4
                }"
              >
                <!-- <InfoListLabel>Xác nhận</InfoListLabel>
                <InfoListValue>{{ groupData?.confirm_code }} </InfoListValue> -->

                <InfoListLabel>Đoàn</InfoListLabel>
                <InfoListValue>{{ groupData?.name }}</InfoListValue>

                <InfoListLabel>Ngày đến đầu</InfoListLabel>
                <InfoListValue>{{
                  groupData?.first_arrival_date
                }}</InfoListValue>

                <InfoListLabel>Ngày đi cuối</InfoListLabel>
                <InfoListValue>{{
                  groupData?.last_departure_date
                }}</InfoListValue>

                <InfoListLabel>Từ ngày</InfoListLabel>
                <InfoListValue>{{ selectedData?.arrive_date }} </InfoListValue>

                <InfoListLabel>Đến ngày</InfoListLabel>
                <InfoListValue>{{ selectedData?.depart_date }}</InfoListValue>

                <InfoListLabel>Số phòng</InfoListLabel>
                <InfoListValue>{{ selectedData?.num_of_room }}</InfoListValue>

                <InfoListLabel>Phòng đã đặt</InfoListLabel>
                <InfoListValue>{{ selectedData?.assign_rooms }}</InfoListValue>

                <InfoListLabel>Hạng phòng</InfoListLabel>
                <InfoListValue>{{
                  selectedData?.room_type_name
                }}</InfoListValue>
              </InfoList>
            </div>
            <div class="das-form-group">
              <div v-loading="roomBookingTableLoading" style="height: 300px">
                <GridVx
                  ref="roomBookingTable"
                  :columns="roomBookingColumns"
                  :rows="roomBookingRows"
                  :context="context"
                  dom-layout="scroll"
                  :auto-size-cell="true"
                  :auto-select-first-row="false"
                  class="agGrid roomBooking-list"
                  @selectionChanged="onSelectedRoomBooking"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            :disabled="!roomBookingRows || roomBookingRows?.length === 0"
            class="btn primary small"
            @click="dialogSelectRoomVisible = true"
          >
            Gán phòng
          </button>

          <button
            :disabled="!roomBookingRows || roomBookingRows?.length === 0"
            class="btn primary small"
            @click="openAutoAssignRoom"
          >
            Tự động gán phòng
          </button>

          <button
            :disabled="
              !roomBookingRows ||
              roomBookingRows?.length === 0 ||
              selectedData === null ||
              selectedRoomBooking == null
            "
            class="btn primary small"
            @click="openRoomDetailDialog"
          >
            Chi tiết
          </button>

          <!-- <button class="btn primary small" @click="openAssignRoomDialog">
            Chọn phòng
          </button> -->
        </div>
        <div class="button-containers close-btn">
          <button
            :disabled="!roomBookingRows || roomBookingRows?.length === 0"
            class="btn primary small"
            @click="fnConfirmRoomBookingList"
          >
            Xác nhận
          </button>
          <button
            class="btn primary small outline"
            @click="dialogUpdateRoomVisible = false"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>
    <groupMasterFunctionsAssignRoomDialog
      v-if="dialogSelectRoomVisible"
      :selected-data="{
        roomNumber: null,
        hotelId: null,
        roomLevelId: selectedData.room_type_id,
        arriveDate: selectedData.arrive_date.split(' ')[0],
        departDate: selectedData.depart_date.split(' ')[0],
        depart_time: depart_time,
        arrive_time: arrive_time
      }"
      :total-rooms="selectedData?.num_of_room"
      @roomSelected="onRoomSelected"
      @close="dialogSelectRoomVisible = false"
    />
    <!--Assign Room Dialog -->

    <!-- detail reservation -->
    <BookingRoomDetailDialog
      v-model="dialogBookingRoomDetailVisible"
      :data="selectedRoomBooking"
      :is-disable="true"
      @onUpdateBookingRoom="onUpdateBookingRoom"
    />
  </div>
</template>

<script>
/* eslint-disable */
// import moment from 'moment'
import groupMasterFunctionsAssignRoomDialog from './groupMasterFunctionsAssignRoomDialog.vue'

// import { CellRenderCheckboxReadonly } from '@/utils/groupCellRenders.js'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import BookingRoomDetailDialog from '@/views/mci/group/components/BookingRoomDetailDialog.vue'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'
import InfoListValue from '@/components/info-list/InfoListValue.vue'
import InfoList from '@/components/info-list/InfoList'
import paginationMixin from '@/mixins/paginationMixin'
import {
  getRoomBookingListApi,
  getRoomListApi,
  getHotelListApi,
  assignAutoRoomApi,
  updateRoomBookingApi
} from '@/api/booking_service/bookingGroup'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'

// import Multiselect from 'vue-multiselect'
export default {
  components: {
    groupMasterFunctionsAssignRoomDialog,
    // SingleCalendar,
    // Multiselect
    BookingRoomDetailDialog,
    InfoList,
    InfoListLabel,
    InfoListValue,
    CalendarSelect
    // CellRenderCheckboxReadonly
  },
  mixins: [paginationMixin],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    groupData: {
      type: Object,
      default: () => {}
    },
    selectedData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      context: null,
      dialogSelectRoomVisible: false,
      cancelRoomExplaination: null,

      selectedRoomBooking: null,

      dialogUpdateRoomVisible: false,
      dialogAssignRoomVisible: false,
      dialogBookingRoomDetailVisible: false,

      roomBookingColumns: [
        {
          headerName: 'STT',
          field: 'no',
          tooltipField: 'no',
          maxWidth: 70
        },
        {
          headerName: 'Mã',
          field: 'room_booking_code',
          // cellRenderer: 'CellRenderTextInput',
          // cellRendererParams: () => {
          //   return {
          //     type: 'text',
          //     colName: 'first_name'
          //   }
          // },
          minWidth: 100
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          minWidth: 70
        },
        // {
        //   headerName: 'SL Khách',
        //   field: 'num_of_guest',
        //   tooltipField: 'num_of_guest',
        //   minWidth: 70
        // },
        {
          headerName: 'SL Người lớn',
          field: 'num_of_guest',
          tooltipField: 'num_of_guest',
          minWidth: 70
        },
        {
          headerName: 'SL Trẻ em',
          field: 'child_num',
          tooltipField: 'child_num',
          minWidth: 70
        },
        {
          headerName: 'SL Trẻ em dưới 5 tuổi',
          field: 'u5_child_num',
          tooltipField: 'u5_child_num',
          minWidth: 70
        }
      ],
      roomBookingRows: [],

      roomBookingTableLoading: false,
      roomLoading: false,

      // filter, option for search room order
      hotelList: [],
      roomLevelList: [],
      statusList: ['VD', 'VC', 'VCI', 'OD', 'OC', 'OCI', 'OOS', 'OOO'],
      searchParams: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null,
        status: null,
        arriveDate: null,
        departDate: null,
        onlyAvailable: true
      },
      searchParamsDefault: {
        roomNumber: null,
        hotelId: null,
        roomLevelId: null,
        status: null,
        arriveDate: null,
        departDate: null,
        onlyAvailable: true
      },
      roomColumns: [
        {
          headerName: 'Khách sạn',
          headerTooltip: 'Khách sạn',
          tooltipField: 'hotel_name',
          field: 'hotel_name'
        },
        {
          headerName: 'Hạng phòng',
          headerTooltip: 'Hạng phòng',
          tooltipField: 'room_level_name',
          field: 'room_level_name'
        },
        {
          headerName: 'Số phòng',
          headerTooltip: 'Số phòng',
          tooltipField: 'room_num',
          field: 'room_num'
        },
        {
          headerName: 'Thuộc tính phòng',
          headerTooltip: 'Thuộc tính phòng',
          tooltipField: 'room_properties',
          field: 'room_properties'
        },
        {
          headerName: 'Trạng thái buồng phòng',
          headerTooltip: 'Trạng thái buồng phòng',
          tooltipField: 'chamber_status',
          field: 'chamber_status'
        },
        {
          headerName: 'Bị chiếm',
          field: 'is_taken',
          cellClass: 'grid-cell-align-center',
          // width: 100,
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      roomRows: [],
      selectedRoom: null,

      selectedProfile: null,

      arrive_time: null,
      depart_time: null
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dialogUpdateRoomVisible = this.dialogVisible
          this.fnGetRoomBookingList()
        }
      }
    },
    selectedData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          const arrive_time = this.$moment(val.arrive_date)
          const depart_time = this.$moment(val.depart_date)
          this.arrive_time = {
            HH: arrive_time.format('HH'),
            mm: arrive_time.format('mm')
          }
          this.depart_time = {
            HH: depart_time.format('HH'),
            mm: depart_time.format('mm')
          }
        }
      }
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {},
  methods: {
    onUpdateBookingRoom(payload) {
      this.dialogBookingRoomDetailVisible = false
      var index = this.roomBookingRows.findIndex(item => item.id == payload.id)
      // console.log(index)
      Object.assign(this.roomBookingRows[index], payload)
      // this.roomBookingRows[id] = payload
      this.$refs.roomBookingTable.gridOptions.api.refreshCells({
        force: true
      })
      // this.fnGetRoomBookingList()
    },
    // DATA
    async fnGetRoomBookingList() {
      this.roomBookingTableLoading = true
      getRoomBookingListApi(this.selectedData.id)
        .then(res => {
          this.roomBookingRows = [
            ...res.data.map((item, index) => {
              return {
                ...item,
                no: index + 1
              }
            })
          ]
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.roomBookingTableLoading = false
        })
    },

    onSelectedRoomBooking(select) {
      this.selectedRoomBooking = select[0]
    },

    openRoomDetailDialog() {
      this.dialogBookingRoomDetailVisible = true
    },

    SelectInputChange(colName, data, value) {
      // console.log('colName', colName, value)
      const idx = data.rowIndex
      this.roomBookingRows[idx][colName] = value
    },

    textInputChange(params, value, colName) {
      const idx = params.rowIndex
      this.roomBookingRows[idx][colName] = value
      // console.log(this.rows[params.rowIndex])
    },

    changeCheckbox(colName, params, value) {
      const idx = params.rowIndex
      this.roomBookingRows[idx][colName] = value
    },

    changeCalendar(params, value, colName) {
      const idx = params.rowIndex
      this.roomBookingRows[idx][colName] = value
      // console.log(this.rows[params.rowIndex])
    },

    async fnAssignRoom() {
      // call api
      // alert('chon phong!!')
      this.roomBookingRows = this.roomBookingRows.map(item => {
        return {
          ...item,
          room_id:
            item.room_booking_no === this.selectedRoomBooking.room_booking_no
              ? this.selectedRoom.room_id
              : item.room_id,
          room_num:
            item.room_booking_no === this.selectedRoomBooking.room_booking_no
              ? this.selectedRoom.room_num
              : item?.room_num
        }
      })
      this.$refs.roomBookingTable.gridOptions.api.forEachNode(node => {
        if (node.room_booking_no === this.selectedRoomBooking.room_booking_no) {
          node.setData(node.data)
        }
      })
      this.dialogAssignRoomVisible = false
    },
    onRoomSelected(rooms) {
      this.roomBookingRows = this.roomBookingRows.map((room, index) => {
        room.room_id = null
        room.room_num = null

        const selectedRoom = rooms[index]
        return {
          ...room,
          room_id: selectedRoom.room_id,
          room_num: selectedRoom.room_num
        }
      })
      this.dialogSelectRoomVisible = false
    },
    async openAutoAssignRoom() {
      var params = {
        roomTypeId: this.selectedData.room_type_id,
        numOfRoom: this.roomBookingRows.length,
        dateFrom: this.$moment(this.selectedData.arrive_date).format(
          'YYYY-MM-DD HH:mm'
        ),
        dateTo: this.$moment(this.selectedData.depart_date).format(
          'YYYY-MM-DD HH:mm'
        )
      }

      await assignAutoRoomApi(params)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Đã tự động gán phòng, vui lòng kiểm tra thông tin.'
          })
          var response = res.data
          this.roomBookingRows = this.roomBookingRows.map((item, index) => {
            return {
              ...item,
              room_id: response[index].id,
              room_num: response[index].room_num
            }
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {})
    },
    fnAddRoomBooking() {
      var addRoomBooking = {}
      addRoomBooking = Object.assign(addRoomBooking, this.selectedRoomBooking)
      addRoomBooking.no = this.roomBookingRows.length + 1
      this.roomBookingRows.push(addRoomBooking)
    },

    // DIALOG
    onCloseUpdateRoomDialog() {
      this.selectedRoomBooking = null
      this.roomBookingRows = []
      this.$emit('closeDialog', 'updateRoomBooking')
    },

    // assign room pop up filter
    async fnGetHotelListApi() {
      await getHotelListApi()
        .then(res => {
          this.hotelList = res.data
          // this.masterGroupPaging.totalPage = Math.ceil(
          //   res.total / this.searchParams.pageSize
          // )
          // this.masterGroupPaging.currentPage = this.searchParams.pageNum
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {})
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    },
    async fnSearchRoomList() {
      this.roomLoading = true

      await getRoomListApi(this.searchParams)
        .then(res => {
          this.roomRows = res.data
          // this.masterGroupPaging.totalPage = Math.ceil(
          //   res.total / this.searchParams.pageSize
          // )
          // this.masterGroupPaging.currentPage = this.searchParams.pageNum
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t(
              'errorMsg.' + error?.response?.data?.message
                ? error?.response?.data?.message
                : error
            )
          })
        })
        .finally(() => {
          this.roomLoading = false
        })
    },
    onReset() {
      this.searchParams = Object.assign(
        this.searchParams,
        this.searchParamsDefault
      )
    },
    onSelectRoom(select) {
      this.selectedRoom = select[0]
    },

    async fnConfirmRoomBookingList() {
      if (
        this.roomBookingRows.filter(item => {
          return !item.room_num
        }).length > 0
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập đủ thông tin phòng.'
        })
        return
      }

      // for (var i = 0; i < this.roomBookingRows.length; i++) {
      //   delete this.roomBookingRows[i].id
      // }
      await updateRoomBookingApi(this.roomBookingRows)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Cập nhập danh sách phòng thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.selectedRoomBooking = null
          this.dialogUpdateRoomVisible = false
          this.roomBookingRows = []
          this.$emit('closeDialog', 'updateRoomBooking', true)
          // this.fnSearchGroupList()
        })
    }
  }
}
</script>

<style scoped>
.w-0 {
  width: 0%;
}
.w-50 {
  width: 50%;
}
.w-33 {
  width: 33%;
}
.w-25 {
  width: 25%;
}
.close-btn {
  padding-top: 10px;
}
.roomBooking-list::v-deep .ag-cell {
  overflow: visible !important;
}
.roomBooking-list::v-deep .ag-row-focus {
  z-index: 1;
}
</style>
